import { z } from "zod";

export const planKeySchema = z.enum(["free", "starter", "pro", "enterprise"]);
export type PlanKey = z.infer<typeof planKeySchema>;

export const billingModeSchema = z.enum(["none", "stripe_subscription", "invoice"]);
export type BillingMode = z.infer<typeof billingModeSchema>;
